export default __webpack_public_path__ + "static/media/message-icon.0e6f0de6.svg";